import { jsx as _jsx } from "react/jsx-runtime";
import { PPCPositionTypesUK } from '@as-react/common-types';
import { isNullOrUndefined } from '@as-react/common-utils';
import { Box, BoxTheme } from '@as/cotopaxi';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { useProductPlacementCopyBox } from './useProductPlacementCopyBox';
export const ProductPlacementCopyBox = ({ ppc }) => {
    const { content, renderedContainerElement, PPCPositionTypes, isExternal } = useProductPlacementCopyBox(ppc);
    if (isNullOrUndefined(content) || content.length === 0)
        return null;
    const getSpacings = () => {
        if (isExternal()) {
            if (ppc.placementPositionId === PPCPositionTypesUK.DIGITAL_PARTNER_MESSAGING) {
                return {
                    mobile: {
                        spacing: {
                            marginBottom: 2,
                        },
                    },
                };
            }
            return {};
        }
        return {
            mobile: {
                spacing: {
                    marginTop: ppc.placementPositionId === PPCPositionTypes.ABOVE_BUY_BUTTON
                        ? 1
                        : ppc.placementPositionId === PPCPositionTypes.BELOW_BUY_BUTTON
                            ? 2
                            : 0,
                    marginBottom: ppc.placementPositionId === PPCPositionTypes.ABOVE_DESCRIPTION ? 3 : 2,
                    paddingTop: 1,
                    paddingRight: 2,
                    paddingBottom: 1,
                    paddingLeft: 2,
                },
                theme: BoxTheme.NOTICE,
            },
            tablet: {
                spacing: {
                    paddingRight: 1,
                    paddingLeft: 1,
                },
            },
        };
    };
    return (_jsx(Box, Object.assign({ mobileBleed: !isExternal() }, getSpacings(), { children: _jsx("div", { ref: renderedContainerElement, children: _jsx(HtmlInclude, { htmlFragment: content }) }) })));
};
